import React, {useState, useCallback} from "react";
import classNames from "classnames";
import ReactGA from 'react-ga';

import {textMap} from "../common/Localization";

import './FAQ.scss';

const FAQ = () => {
	const [faq1, setFaq1] = useState(false);
	const [faq2, setFaq2] = useState(false);
	const [faq3, setFaq3] = useState(false);
	const [faq4, setFaq4] = useState(false);
	const [faq5, setFaq5] = useState(false);
	const [faq6, setFaq6] = useState(false);

	const onToggleFaq1 = useCallback(() => {
		if(!faq1) {
			ReactGA.event({
				category:"PARTNER",
				action:"FAQ",
				label:"FAQ-질문1"
			});
		}
		setFaq1(!faq1);
	}, [faq1]);
	const onToggleFaq2 = useCallback(() => {
		if(!faq2) {
			ReactGA.event({
				category:"PARTNER",
				action:"FAQ",
				label:"FAQ-질문2"
			});
		}
		setFaq2(!faq2);
	}, [faq2]);
	const onToggleFaq3 = useCallback(() => {
		if(!faq3) {
			ReactGA.event({
				category:"PARTNER",
				action:"FAQ",
				label:"FAQ-질문3"
			});
		}
		setFaq3(!faq3);
	}, [faq3]);
	const onToggleFaq4 = useCallback(() => {
		if(!faq4) {
			ReactGA.event({
				category:"PARTNER",
				action:"FAQ",
				label:"FAQ-질문4"
			});
		}
		setFaq4(!faq4);
	}, [faq4]);
	const onToggleFaq5 = useCallback(() => {
		if(!faq5) {
			ReactGA.event({
				category:"PARTNER",
				action:"FAQ",
				label:"FAQ-질문5"
			});
		}
		setFaq5(!faq5);
	}, [faq5]);
	const onToggleFaq6 = useCallback(() => {
		if(!faq6) {
			ReactGA.event({
				category:"PARTNER",
				action:"FAQ",
				label:"FAQ-질문6"
			});
		}
		setFaq6(!faq6);
	}, [faq6]);

	return (
		<div id="faq" className="bc_light_blue view_section">
			<div className="faq_wrap">
				<div className={classNames("title", "c_28")}>{textMap.formatString(textMap.faq_title, <span className="c_blue">{textMap.faq_title_2}</span>)}</div>
				<div className="faq_item_wrap">
					<div className="faq_column">
						<div className={classNames("faq_item", "lc_ce", faq1 ? "open" : "")} onClick={onToggleFaq1}>
							<div className={classNames("question")}>
								<span className={classNames("faq_text", faq1 ? "c_blue" : "c_28")}>{textMap.faq_q_1}</span>
								<span className={classNames("faq_button", "cbc_blue")}>
									<img className="plus_icon" src={process.env.PUBLIC_URL + "/icon/plus_white.png"} alt=""/>
									<img className="minus_icon" src={process.env.PUBLIC_URL + "/icon/minus_white.png"} alt=""/>
								</span>
							</div>
							<div className={classNames("answer", "c_69")}>
								{textMap.faq_a_1}
							</div>
						</div>
						<div className={classNames("faq_item", "lc_ce", faq2 ? "open" : "")} onClick={onToggleFaq2}>
							<div className={classNames("question")}>
								<span className={classNames("faq_text", faq2 ? "c_blue" : "c_28")}>{textMap.faq_q_2}</span>
								<span className={classNames("faq_button", "cbc_blue")}>
									<img className="plus_icon" src={process.env.PUBLIC_URL + "/icon/plus_white.png"} alt=""/>
									<img className="minus_icon" src={process.env.PUBLIC_URL + "/icon/minus_white.png"} alt=""/>
								</span>
							</div>
							<div className={classNames("answer", "c_69")}>
								{textMap.faq_a_2}
							</div>
						</div>
						<div className={classNames("faq_item", "lc_ce", faq3 ? "open" : "")} onClick={onToggleFaq3}>
							<div className={classNames("question")}>
								<span className={classNames("faq_text", faq3 ? "c_blue" : "c_28")}>{textMap.faq_q_3}</span>
								<span className={classNames("faq_button", "cbc_blue")}>
									<img className="plus_icon" src={process.env.PUBLIC_URL + "/icon/plus_white.png"} alt=""/>
									<img className="minus_icon" src={process.env.PUBLIC_URL + "/icon/minus_white.png"} alt=""/>
								</span>
							</div>
							<div className={classNames("answer", "c_69")}>
								{textMap.faq_a_3}
							</div>
						</div>
					</div>
					<div className="faq_column">
						<div className={classNames("faq_item", "lc_ce", faq4 ? "open" : "")} onClick={onToggleFaq4}>
							<div className={classNames("question")}>
								<span className={classNames("faq_text", faq4 ? "c_blue" : "c_28")}>{textMap.faq_q_4}</span>
								<span className={classNames("faq_button", "cbc_blue")}>
									<img className="plus_icon" src={process.env.PUBLIC_URL + "/icon/plus_white.png"} alt=""/>
									<img className="minus_icon" src={process.env.PUBLIC_URL + "/icon/minus_white.png"} alt=""/>
								</span>
							</div>
							<div className={classNames("answer", "c_69")}>
								{textMap.faq_a_4}
							</div>
						</div>
						<div className={classNames("faq_item", "lc_ce", faq5 ? "open" : "")} onClick={onToggleFaq5}>
							<div className={classNames("question")}>
								<span className={classNames("faq_text", faq5 ? "c_blue" : "c_28")}>{textMap.faq_q_5}</span>
								<span className={classNames("faq_button", "cbc_blue")}>
									<img className="plus_icon" src={process.env.PUBLIC_URL + "/icon/plus_white.png"} alt=""/>
									<img className="minus_icon" src={process.env.PUBLIC_URL + "/icon/minus_white.png"} alt=""/>
								</span>
							</div>
							<div className={classNames("answer", "c_69")}>
								{textMap.faq_a_5}
							</div>
						</div>
						<div className={classNames("faq_item", "lc_ce", faq6 ? "open" : "")} onClick={onToggleFaq6}>
							<div className={classNames("question")}>
								<span className={classNames("faq_text", faq6 ? "c_blue" : "c_28")}>{textMap.faq_q_6}</span>
								<span className={classNames("faq_button", "cbc_blue")}>
									<img className="plus_icon" src={process.env.PUBLIC_URL + "/icon/plus_white.png"} alt=""/>
									<img className="minus_icon" src={process.env.PUBLIC_URL + "/icon/minus_white.png"} alt=""/>
								</span>
							</div>
							<div className={classNames("answer", "c_69")}>
								{textMap.faq_a_6}
							</div>
						</div>
					</div>	
				</div>				
			</div>
		</div>
	);
};

export default FAQ;
